import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FloatingCallButton from "./components/FloatingCallButton";
import ScrollToTop from "./components/ScrollToTop";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Doctors from "./pages/Doctors";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import Blogs from "./pages/Blogs";
import BlogDetail from "./pages/BlogDetail";
import MedicalFacilities from "./pages/MedicalFacilities";
import MedicalFacilityDetail from "./pages/MedicalFacilityDetail";

function App() {
  return (
    <>
      {/* 👇 Ye line scroll issue fix karti hai */}
      <ScrollToTop />

      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/doctors" element={<Doctors />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />

        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />

        <Route path="/medical-facilities" element={<MedicalFacilities />} />
        <Route
          path="/medical-facilities/:id"
          element={<MedicalFacilityDetail />}
        />
      </Routes>

      <Footer />
      <FloatingCallButton />
    </>
  );
}

export default App;
